<template>
  <SoPageWithHeader title="Jobs">
    <SoButton
      type="text"
      title="Back to services"
      prepend-icon="arrow-left"
      class="mb-4 px-0"
      data-testid="service-jobs-back-btn"
      :to="{ name: RouteNames.AdminServices }"
    />

    <div class="pt-4">
      <SoAlert
        v-if="query?.isError"
        type="error"
        title="Failed to load jobs"
        data-testid="service-jobs-error"
      />

      <SoDataTable
        v-else
        :headers="headers"
        :items="jobs"
        :loading="isLoading"
        :row-clickable="false"
        :searchable="false"
        :has-pagination="false"
        data-testid="service-jobs-table"
      >
        <template #item.name="{ internalItem }">
          <div class="py-1">
            <div>{{ internalItem.raw.nameDisplay }}</div>
            <div
              v-if="internalItem.raw.cronDescription"
              class="text-caption text-medium-emphasis"
            >
              {{ internalItem.raw.cronDescription }}
            </div>
          </div>
        </template>

        <template #item.cron="{ internalItem }">
          <span class="text-no-wrap">{{ internalItem.raw.cronDisplay }}</span>
        </template>
      </SoDataTable>
    </div>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoDataTable from "@/components/dataTable/SoDataTable.vue"
  import {
    SoDataTableHeader,
    SoDataTableItem,
  } from "@/types/components/SoDataTable"
  import { ServiceJobsService } from "@/services/admin/ServiceJobsService"
  import { IServiceJob } from "@/models/admin/serviceJob/serviceJob.types"
  import { QueryResult } from "@/api/utils/types"
  import { RouteNames } from "@/types/router"

  type JobRow = IServiceJob & SoDataTableItem

  const headers: SoDataTableHeader[] = [
    { title: "Name", key: "name", sortable: true },
    { title: "Cron", key: "cron", sortable: true },
  ]

  export default defineComponent({
    components: {
      SoAlert,
      SoPageWithHeader,
      SoButton,
      SoDataTable,
    },
    data() {
      return {
        RouteNames,
        headers,
        query: null as QueryResult<IServiceJob[]> | null,
      }
    },
    computed: {
      isLoading(): boolean {
        return this.query?.isFetching ?? false
      },
      jobs(): JobRow[] {
        return (this.query?.data ?? []) as JobRow[]
      },
    },
    mounted() {
      this.query = ServiceJobsService.getJobs()
    },
  })
</script>
